import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ConstructionSiteService } from 'src/app/services/archive/construction-site.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-deactivate-construction-site-errors-modal',
  templateUrl: './deactivate-construction-site-errors-modal.component.html',
  styleUrls: ['./deactivate-construction-site-errors-modal.component.scss'],
  standalone: false
})
export class DeactivateConstructionSiteErrorsModalComponent implements OnInit, OnDestroy {

  invoiceAlerts: Array<PreInvoicingAlertModel> = [];
  errorInvoice: number = 0;
  subscription?: Subscription;

  constructor(
    public config: DynamicDialogConfig,
    private constructionSiteService: ConstructionSiteService,
    private toastHandlerService: ToastHandlerService
  ) { }

  ngOnInit(): void {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = input$.subscribe((inputs: any) => {
      this.invoiceAlerts = inputs.invoiceAlerts || [];
      this.errorInvoice = inputs.errorInvoice || 0;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  downloadErrorsTxt() {
    if (!this.invoiceAlerts || this.invoiceAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.constructionSiteService.exportImportErrors(this.invoiceAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresInactivacionObras_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }
}
